import { createSelector } from '@ngrx/store';

import { selectCompareState } from '@cdba/core/store/reducers';

import { CompareState, ComparisonState } from '../..';

export const getComparisonState = createSelector(
  selectCompareState,
  (state: CompareState): ComparisonState => state.comparison
);

export const getComparisonError = createSelector(
  getComparisonState,
  (comparison: ComparisonState): string => comparison?.errorMessage
);

export const isComparisonLoading = createSelector(
  getComparisonState,
  (comparison: ComparisonState): boolean => comparison?.loading
);
